import Yup from "../validation/yup";
const VERSION = 1;
export class PaymentFormModel {
    constructor() {
        this.method = PaymentMethodValues.DISCOUNT_CODE;
        this.dicountCode = '';
        this.firstName = '';
        this.lastName = '';
        this.email = '';
        this.phone = '';
        this.street = '';
        this.city = '';
        this.postalCode = '';
        this.region = '';
        this.country = '';
        this.licenceAgreement = false;
        this.marketingAgreement = true;
    }
    static get validationSchema() {
        return Yup.object({
            method: Yup.string().required(),
            dicountCode: Yup.string().when('method', {
                is: (val) => PaymentMethodValues.DISCOUNT_CODE === val,
                then: Yup.string().min(5).required(),
                otherwise: Yup.string().notRequired(),
            }),
            licenceAgreement: Yup.boolean().required().isTrue({ key: 'common:licenceAgreementKO' }),
            // firstName: Yup.string().max(255).trim().required(),
            // lastName: Yup.string().max(255).trim().required(),
            // email: Yup.string().lowercase().email().required(),
            // phone: Yup.string().matches(PHONE_REGEX).required(),
            // street: Yup.string().max(255).trim().required(),
            // city: Yup.string().max(255).trim().required(),
            // postalCode: Yup.string().matches(POSTALCODE_REGEX, () => ({ key: 'common:formValidation.postalCodeFormat' })).required(),
            // region: Yup.string().max(255).trim().required(),
            // country: Yup.string().max(255).trim().required()
        });
    }
}
PaymentFormModel.VERSION = VERSION;
export var PaymentMethodValues;
(function (PaymentMethodValues) {
    PaymentMethodValues["CARD"] = "card";
    PaymentMethodValues["DISCOUNT_CODE"] = "discountCode";
})(PaymentMethodValues || (PaymentMethodValues = {}));
export default {
    PaymentFormModel,
    PaymentMethodValues
};
